import classNames from 'classnames';
import {Link} from 'gatsby';
import logoWhite from "images/logo-white.png";
import React from 'react';
import Style from 'styles/components/footer.module.scss';

const Footer = () => {
  return (
    <div className={classNames(Style.footer)}>
      <div className={Style.footer__main}>
        <div className={Style.footer__logo}>
          <Link to="/">
            <img src={logoWhite} alt="ComachiCart ロゴ" />
          </Link>
        </div>
        <div className={Style.footer__links}>
          <div className={Style.footer__section}>
            <p className={Style.footer__title}>サービス紹介</p>
            <div className={Style.footer__columns}>
              <ul>
                <li><Link to="/func/">機能</Link></li>
                <li><Link to="/design/">デザイン</Link></li>
                <li><Link to="/price/">料金</Link></li>
                <li><Link to="/case_study/">事例</Link></li>
              </ul>
              <ul>
                <li><Link to="/know_how/">BLOG</Link></li>
                <li><Link to="/news/">お知らせ</Link></li>
                <li><Link to="/faq/">よくある質問</Link></li>
                <li><a href="https://e-ize.jp/contact/" target="_blank" rel="noopener noreferrer">お問い合わせ</a></li>
              </ul>
            </div>
          </div>
          <div className={Style.footer__section}>
            <p className={Style.footer__title}>企業情報</p>
            <div className={Style.footer__columns}>
              <ul>
                <li><a href="https://e-ize.jp/" target="_blank" rel="noopener noreferrer">運営会社</a></li>
                <li><a href="https://e-ize.jp/recruit/" target="_blank" rel="noopener noreferrer">採用情報</a></li>
                <li><a href="https://e-ize.jp/tokushoho/" target="_blank" rel="noopener noreferrer">特商法表記</a></li>
                <li><a href="https://e-ize.jp/privacy/" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className={Style.footer__copyright}>
        Copyright© e-ize Co.Ltd. All Rights Reserved.
      </div>
    </div>
  );
};

export default Footer;
